import { matchPath } from 'react-router';
import { isFunction, removeTrailingSlash } from '../../../utils';
/*
 * @param {String} [url] a url to match against routeTrails.
 * @param {Object} [context] a object holding context to enable title creation
 * @param {RouteTrail[]} [routeTrails] define breadcrumbs based on route paths.
 *
 * @return {breadCrumb} Holding information to render a clickable item or link.
 */
function createBreadCrumb(url, context, routeTrails) {
  const breadCrumb = routeTrails
    .map((trailDefinition) => {
      const match = matchPath(trailDefinition.route, url);

      return {
        ...trailDefinition,
        match,
        title:
          match && isFunction(trailDefinition.title)
            ? trailDefinition.title(context, match)
            : trailDefinition.title,
      };
    })
    .find((c) => c.match);
  return breadCrumb;
}

function routeTrail({ context, routeTrails, url }) {
  let currentUrl = '';

  return (
    url
      .split('/')
      .map((urlPart) => {
        if (urlPart) {
          currentUrl = `${currentUrl}/${urlPart}`;
        }
        return currentUrl;
      })
      .map((currentUrl_) => createBreadCrumb(currentUrl_, context, routeTrails))
      .filter(Boolean) || []
  );
}

function getNewUrl({ activeTree, url }) {
  let newUrl = removeTrailingSlash(url).replaceAll(/\/pages\/\d*.*/gm, '');
  if (activeTree?.page >= 0) {
    newUrl = `${newUrl}/pages/${activeTree.page}`;
  }
  if (activeTree?.section >= 0) {
    newUrl = `${newUrl}/sections/${activeTree.section}`;
  }
  if (activeTree?.column >= 0) {
    newUrl = `${newUrl}/columns/${activeTree.column}`;
  }
  if (activeTree?.panel >= 0) {
    newUrl = `${newUrl}/panels/${activeTree.panel}`;
  }
  return newUrl;
}

const LAYOUT_TREE_KEYS = {
  pages: 'page',
  sections: 'section',
  columns: 'column',
  panels: 'panel',
};

/*
 * @param {String} [splat] the part of the layout route after `/layout/`, e.g. `pages/2/sections/0`.
 *
 * @return {Object} the `page`, `section`, `column` and `panel` values present in the path.
 */
function parseLayoutPath(splat = '') {
  const parts = splat.split('/').filter(Boolean);
  const tree = {};
  for (let index = 0; index < parts.length - 1; index += 2) {
    const key = LAYOUT_TREE_KEYS[parts[index]];
    if (key) {
      tree[key] = parts[index + 1];
    }
  }
  return tree;
}

export { createBreadCrumb, routeTrail, getNewUrl, parseLayoutPath };
